import React, { useState, useEffect } from "react"
import { abbreviateTime } from "../../../Templates/functions"
import moment from 'moment';

const abbreviateLongText = (text) => {
    if(text && text.length > 52){
        return text.substring(0, 55) + "...";
    }
    return text;
}

// Function to abbreviate text if it's over 35 characters long
const abbreviateText = (text) => {
  if (text && text.length > 35) {
    return text.substring(0, 32) + "...";
  }
  return text;
};

const NotificationItem = (props) => {
  // State to track the screen width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Function to update the screen width when the window is resized
  const handleResize = () => {
      setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
      // Add an event listener to track window resize
      window.addEventListener("resize", handleResize);

      // Clean up the event listener when the component unmounts
      return () => {
          window.removeEventListener("resize", handleResize);
      };
  }, []);

  // Determine whether to abbreviate the text based on screen width
  const shouldAbbreviateText = windowWidth < 1500;

  return (
      <li className={`flex feed-notification-item news${props.read ? "" : "-unread"}`}>
          <div id="feed-notification-item-info" className="flex-column news">
              {/* Use abbreviateText conditionally based on screen width */}
              <p className="ellipsis">{shouldAbbreviateText ? abbreviateText(props.message) : abbreviateLongText(props.message)}</p>
          </div>
          <p className="notification-timestamp">{moment.utc(props.createdAt).local().format("MM/DD/YYYY hh:mm A")}</p>
          {/* <p className="notification-timestamp">{abbreviateTime(moment.utc(props.createdAt).local().fromNow())}</p> */}
      </li>
  );
}

export default NotificationItem;
